import axios from './axios'
import Bid from '@/model/bid'

export default {
  async create (bid) {
    const result = await axios.post('/bid/create', bid)
    return Bid.setClass(result.bid)
  },
  async cancelTrade (bidId, orgId) {
    const params = {
      bidId: bidId,
      orgId: orgId
    }
    const result = await axios.put('/bid/cancel-trade', params)
    return Bid.setClass(result.bid)
  },
  async reject (bidId, comment, orgId) {
    const params = {
      bidId: bidId,
      comment: comment,
      orgId: orgId
    }
    const result = await axios.put('/bid/reject', params)
    return Bid.setClass(result.bid)
  },
  async buyerAccept (bidId, comment, orgId) {
    const params = {
      bidId: bidId,
      comment: comment,
      orgId: orgId
    }
    const result =  await axios.put('/bid/buyer-accept', params)
    return Bid.setClass(result.bid)
  },
  async sellerAccept (bidId, comment, orgId, sellerAcceptsNoInsurance = false) {
    const params = {
      bidId: bidId,
      comment: comment,
      orgId: orgId
    }
    if (sellerAcceptsNoInsurance) {
      params.sellerAcceptsNoInsurance = true
    }
    const result =  await axios.put('/bid/seller-accept', params)
    return Bid.setClass(result.bid)
  },
  async withdraw (bidId, comment, orgId) {
    const params = {
      bidId: bidId,
      comment: comment,
      orgId: orgId
    }
    const result =  await axios.put('/bid/withdraw', params)
    return Bid.setClass(result.bid)
  },
  async buyerCounter (bidId, quantity, price, comment, orgId , counterPaymentTerm, counterTransferType, counterTransferStartDate, counterTransferEndDate, counterDeliveryLocation) {
    const params = {
      bidId: bidId,
      counterQuantity: quantity,
      counterPrice: price,
      comment: comment,
      orgId: orgId,
      counterPaymentTerm: counterPaymentTerm,
      counterTransferType: counterTransferType,
      counterTransferStartDate: counterTransferStartDate,
      counterTransferEndDate: counterTransferEndDate,
      counterDeliveryLocation: counterDeliveryLocation
    }
    const result =  await axios.put('/bid/buyer-counter', params)
    return Bid.setClass(result.bid)
  },
  async sellerCounter (bidId, quantity, price, comment, orgId, counterPaymentTerm, counterTransferType, counterTransferStartDate, counterTransferEndDate, counterDeliveryLocation, sellerAcceptsNoInsurance = false) {
    const params = {
      bidId: bidId,
      counterQuantity: quantity,
      counterPrice: price,
      comment: comment,
      orgId: orgId,
      counterPaymentTerm: counterPaymentTerm,
      counterTransferType: counterTransferType,
      counterTransferStartDate: counterTransferStartDate,
      counterTransferEndDate: counterTransferEndDate,
      counterDeliveryLocation: counterDeliveryLocation
    }
    if (sellerAcceptsNoInsurance) {
      params.sellerAcceptsNoInsurance = true
    }
    const result =  await axios.put('/bid/seller-counter', params)
    return Bid.setClass(result.bid)
  },
  async paid (bidId, orgId) {
    const params = {
      bidId: bidId,
      orgId: orgId
    }
    const result =  await axios.put('/bid/paid', params)
    return Bid.setClass(result.bid)
  },
  async getBid (bidId) {
    const result = await axios.get('/bid/' + bidId)
    return Bid.setClass(result.bid)
  },

  async downloadBrokerNote (bidId) {
    const result = await axios.get('/bid/' + bidId + '/downloadbrokernote', {responseType: 'blob'})
    console.log('downloadBrokerNote', result)
    return result
  },

  async getBids (buyerSeller = 'BUYER', numberOfItems, page, state, orgs) {
    const orgKey = buyerSeller === 'BUYER' ? 'buyerOrgs' : 'sellerOrgs'
    const params = {
      numberOfItems: numberOfItems,
      page: page
    }
    if (orgs) { params[orgKey] = orgs }
    if (state) { params.state = state }
    const result = await axios.post('/bid/list', params)
    Bid.setClasses(result.data)
    return result
  },
  async getRecentSold () {
    const result = await axios.get('/bid/recent-sold')
    Bid.setClasses(result.data)
    return result
  }
}

